import React, {Component} from 'react';
import { Row, Col } from 'antd';
import { Search } from 'modules/header';
import {Carousel} from 'modules/carousel';
import FeedListContainer from './FeedListContainer';
import FacebookFeedListLayout from './FacebookFeedListLayout';
import NewsFeedListLayout from './NewsFeedListLayout';
import MediaTypeList from './MediaTypeList';
import InstantNewsLayout from './InstantNewsLayout';
import LatestRepliesLayout from './LatestRepliesLayout';
import { fetchLatestFeed, latesClickMediaType, fetchNewsLatestFeed, fetchFacebookLatestFeed } from '../actions';
import {connect} from 'react-redux';
import createSelector from 'helpers/createSelector';
import _ from 'lodash';
import classnames from 'classnames';

const container = connect(
  createSelector(
    (state) => ({
    })
    ,
    (state) => {
      return {
      }
    }
  )
)

const Home = ({dispatch}) => {

  const diapatchLatestFeed = (action) => {
    // localStorage.defaultMediaType = action.query.mediaType;
    dispatch(fetchLatestFeed(action));
  }

  const dispatchNewsLatesFeed = (action) => {
    dispatch(fetchNewsLatestFeed(action));
  }

  const dispatchFacebookLatesFeed = (action) => {
    dispatch(fetchFacebookLatestFeed(action));
  }

  return (
    <div className="body-background">
     <div className="margin-bottom-md">
        <Carousel />
      </div>
      <div className="padding-top-md row2">
        <Row>
          <Col span="15">
            <InstantNewsLayout />
          </Col>
          <Col span="9">
            <div className="">
              <NewsFeedListLayout
                dispatch={dispatchNewsLatesFeed}
                originDispatch={dispatch}/>
            </div>
          </Col>
        </Row>
        <div className="margin-top-xmd">
         <MediaTypeList />
        </div>
        <div>
          <div className="information-feed-list" style={{ background: '#fff', paddingTop: "15px", minHeight: '380px', position: 'relative', paddingBottom: "31px"}}>
            <FeedListContainer dispatch={diapatchLatestFeed} originDispatch={dispatch}/>
          </div>
        </div>
        <Row className="margin-top-xmd margin-bottom-md">
          <Col span="15" className="padding-right-lg">
            <LatestRepliesLayout />
          </Col>
          <Col span="9">
            <div>
              <FacebookFeedListLayout  dispatch={dispatchFacebookLatesFeed} originDispatch={dispatch}/>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  )
}

export default container(Home);



/** WEBPACK FOOTER **
 ** ./src/app/modules/home/components/Component.js
 **/